const asyncActionType = (type) => ({
  PENDING: `${type}_START`,
  SUCCESS: `${type}_SUCCESS`,
  ERROR: `${type}_ERROR`,
});

/** -----------------------------------------------------------
 *                       AUTHENTICATION
 * ---------------------------------------------------------- */

const auth = {
  login: asyncActionType("LOGIN"),
  logout: asyncActionType("LOGOUT"),
};

export const LOGIN = auth.login;
export const SET_USER = "SET_USER";
export const SET_TOKEN = "SET_TOKEN";
export const LOGOUT = auth.logout;

/** -----------------------------------------------------------
 *                       GENERAL
 * ---------------------------------------------------------- */

export const SET_UI_USER_TIMEZONE = "SET_UI_USER_TIMEZONE";

export const SET_LOCALE = "SET_LOCALE";
export const SET_LOADING = "SET_LOADING";
export const SET_TIMEZONE = "SET_TIMEZONE";

export const GLOBAL_SEARCH = asyncActionType("GLOBAL_SEARCH");
export const SET_LEFT_NAV_COLLAPSED = "SET_LEFT_NAV_COLLAPSED";

/** -----------------------------------------------------------
 *                            ACCOUNT
 * ----------------------------------------------------------- */

export const SET_CUSTOMER = "SET_CUSTOMER";
export const SCREEN_SHARING = "SCREEN_SHARING";
export const UPDATE_CUSTOMER_PROFILE = "UPDATE_CUSTOMER_PROFILE";
export const SET_VERIFICATION_CHANNELS = "SET_VERIFICATION_CHANNELS";
export const IS_FIRST_VERIFICATION_ATTEMPT = "IS_FIRST_VERIFICATION_ATTEMPT";

// import { FETCH_RECIPES } from 'constants/action-types';

const account = {
  general: asyncActionType("FETCH_ACCOUNT_GENERAL"),
  locations: asyncActionType("FETCH_ACCOUNT_LOCATIONS"),
  locationUsers: asyncActionType("FETCH_ACCOUNT_LOCATION_USERS"),
  locationDevices: asyncActionType("FETCH_ACCOUNT_LOCATION_DEVICES"),
  addDeviceUser: asyncActionType("ADD_DEVICE_USER"),
  removeDeviceUser: asyncActionType("REMOVE_DEVICE_USER"),
  deviceList: asyncActionType("FETCH_DEVICE_LIST"),
  simpleDeviceList: asyncActionType("FETCH_SIMPLE_DEVICE_LIST"),
  devicesRegistries: asyncActionType("FETCH_DEVICE_REGISTRIES"),
};

export const FETCH_ACCOUNT_GENERAL = account.general;
export const FETCH_ACCOUNT_LOCATIONS = account.locations;
export const FETCH_ACCOUNT_LOCATION_USERS = account.locationUsers;
export const FETCH_ACCOUNT_LOCATION_DEVICES = account.locationDevices;
export const ADD_DEVICE_USER = account.addDeviceUser;
export const REMOVE_DEVICE_USER = account.removeDeviceUser;
export const FETCH_DEVICE_LIST = account.deviceList;
export const FETCH_SIMPLE_DEVICE_LIST = account.simpleDeviceList;
export const FETCH_DEVICE_REGISTRIES = account.devicesRegistries;

/** -----------------------------------------------------------
 *                            NOTES/TAGS
 * ----------------------------------------------------------- */
const notesTags = {
  notes: asyncActionType("FETCH_NOTES"),
  removeNotes: asyncActionType("DELETE_NOTES"),
  tags: asyncActionType("FETCH_TAGS"),
  removeTag: asyncActionType("DELETE_TAGS"),
};

export const FETCH_NOTES = notesTags.notes;
export const DELETE_NOTES = notesTags.removeNotes;
export const FETCH_TAGS = notesTags.tags;
export const DELETE_TAGS = notesTags.removeTag;

/** -----------------------------------------------------------
 *                            DEVICES
 * ----------------------------------------------------------- */
const devices = {
  general: asyncActionType("FETCH_DEVICE"),
  warranty: asyncActionType("FETCH_DEVICE_WARRANTY"),
  diagnostics: asyncActionType("FETCH_DEVICE_DIAGNOSTICS"),
  location: asyncActionType("FETCH_DEVICE_LOCATION"),
  locationDetails: asyncActionType("FETCH_DEVICE_LOCATION_DETAILS"),
  events: asyncActionType("FETCH_DEVICE_EVENTS"),
  setupHistory: asyncActionType("FETCH_SETUP_HISTORY"),
  ownership: asyncActionType("FETCH_DEVICE_OWNERSHIP"),
  connected: asyncActionType("FETCH_CONNECTED_CLIENT_DEVICES"),
  statusReport: asyncActionType("FETCH_STATUS_REPORT"),
  lastStatusReport: asyncActionType("FETCH_LAST_STATUS_REPORT"),
  deviceStatus: asyncActionType("SET_DEVICE_STATUS"),
};

export const FETCH_DEVICE = devices.general;
export const FETCH_DEVICE_WARRANTY = devices.warranty;
export const FETCH_DEVICE_DIAGNOSTICS = devices.diagnostics;
export const FETCH_DEVICE_LOCATION = devices.location;
export const FETCH_DEVICE_LOCATION_DETAILS = devices.locationDetails;
export const FETCH_DEVICE_EVENTS = devices.events;
export const FETCH_SETUP_HISTORY = devices.setupHistory;
export const FETCH_DEVICE_OWNERSHIP = devices.ownership;
export const FETCH_CONNECTED_CLIENT_DEVICES = devices.connected;
export const FETCH_STATUS_REPORT = devices.statusReport;
export const FETCH_LAST_STATUS_REPORT = devices.lastStatusReport;
export const SET_DEVICE_STATUS = devices.deviceStatus;
export const RESET_DEVICE_STATUS = "RESET_DEVICE_STATUS";
export const UPDATE_DEVICE_PROFILE = "UPDATE_DEVICE_PROFILE";

/** -----------------------------------------------------------
 *                       DEVICE SETTINGS
 * ----------------------------------------------------------- */
const settings = {
  settings: asyncActionType("FETCH_DEVICE_SETTINGS"),
  update: asyncActionType("UPDATE_DEVICE_SETTINGS"),
  motionSchedule: asyncActionType("FETCH_MOTION_SCHEDULE_SETTING"),
  addMotionSchedule: asyncActionType("ADD_MOTION_SCHEDULE_SETTING"),
  deleteMotionSchedule: asyncActionType("DELETE_MOTION_SCHEDULE_SETTING"),
};
export const FETCH_DEVICE_SETTINGS = settings.settings;
export const UPDATE_DEVICE_SETTINGS = settings.update;
export const FETCH_MOTION_SCHEDULE_SETTING = settings.motionSchedule;
export const ADD_MOTION_SCHEDULE_SETTING = settings.addMotionSchedule;
export const DELETE_MOTION_SCHEDULE_SETTING = settings.deleteMotionSchedule;

/** -----------------------------------------------------------
 *                            NOTES/TAGS
 * ----------------------------------------------------------- */

/** -----------------------------------------------------------
 *                            HISTORY
 * ----------------------------------------------------------- */
let history = {
  deviceStatusReport: asyncActionType("FETCH_ACCOUNT_DEVICE_STATUS_REPORT"),
  deviceEvents: asyncActionType("FETCH_ACCOUNT_DEVICE_EVENTS"),
};

export const FETCH_ACCOUNT_DEVICE_STATUS_REPORT = history.deviceStatusReport;
export const FETCH_ACCOUNT_DEVICE_EVENTS = history.deviceEvents;

/** -----------------------------------------------------------
 *                            REQUESTS
 * ----------------------------------------------------------- */
const requests = {
  requests: asyncActionType("FETCH_ACCOUNT_REQUESTS"),
};

export const SET_REQUEST_GENERAL_DATA = "SET_REQUEST_GENERAL_DATA";
export const SET_REQUEST_CUSTOMER_DATA = "SET_REQUEST_CUSTOMER_DATA";
export const SET_REQUEST_PRODUCT_DATA = "SET_REQUEST_PRODUCT_DATA";
export const SET_REQUEST_MISC_DATA = "SET_REQUEST_MISC_DATA";
export const SET_REQUEST_REASONS_DATA = "SET_REQUEST_REASONS_DATA";
export const SET_REQUEST_ADDRESS_DATA = "SET_REQUEST_ADDRESS_DATA";
export const RESET_REQUEST_DATA = "RESET_REQUEST_DATA";
export const UPDATE_REQUEST_DATA = "UPDATE_REQUEST_DATA";
export const FETCH_ACCOUNT_REQUESTS = requests.requests;

/** -----------------------------------------------------------
 *                             SHARED
 * ------------------------------------------------------------ */
const shared = {
  products: asyncActionType("FETCH_PRODUCTS"),
  countries: asyncActionType("FETCH_COUNTRIES"),
  countryStates: asyncActionType("FETCH_COUNTRY_STATES"),
  reasons: asyncActionType("FETCH_REASONS"),
  markets: asyncActionType("FETCH_MARKETS"),
  retailers: asyncActionType("FETCH_RETAILERS"),
  looker: asyncActionType("FETCH_LOOKER_TOKEN"),
  permissions: asyncActionType("FETCH_PERMISSIONS"),
  feature_flags: asyncActionType("FETCH_FEATURE_FLAGS"),
  roles: asyncActionType("FETCH_ROLES"),
};

export const FETCH_REASONS = shared.reasons;
export const FETCH_PRODUCTS = shared.products;
export const FETCH_RETAILERS = shared.retailers;
export const FETCH_LOOKER_TOKEN = shared.looker;
export const FETCH_COUNTRIES = shared.countries;
export const FETCH_COUNTRY_STATES = shared.countryStates;
export const FETCH_PERMISSIONS = shared.permissions;
export const FETCH_FEATURE_FLAGS = shared.feature_flags;
export const FETCH_ROLES = shared.roles;
export const SET_SHOPIFY_PRODUCTS = "SET_SHOPIFY_PRODUCTS";
export const SET_SHOPIFY_CUSTOMER = "SET_SHOPIFY_CUSTOMER";
export const SET_SHOPIFY_SHIPPING_ADDRESS = "SET_SHOPIFY_SHIPPING_ADDRESS";
export const SET_SHOPIFY_BILLING_ADDRESS = "SET_SHOPIFY_BILLING_ADDRESS";
export const RESET_SHOPIFY_FORM = "RESET_SHOPIFY_FORM";
export const UPDATE_SHOPIFY_ADDRESS = "UPDATE_SHOPIFY_ADDRESS";
export const UPDATE_SHOPIFY_CUSTOMER = "UPDATE_SHOPIFY_CUSTOMER";
export const SET_SHOPIFY_DISCOUNT = "SET_SHOPIFY_DISCOUNT";
export const SET_SHOPIFY_SHIPPING_INFO = "SET_SHOPIFY_SHIPPING_INFO";
export const SET_DRAFT_ORDER = "SET_DRAFT_ORDER";
export const FETCH_MARKETS = shared.markets;
export const FETCH_ACCOUNT_APP_ACTIVITY_PROFILE =
  "FETCH_ACCOUNT_APP_ACTIVITY_PROFILE";
export const FETCH_ACCOUNT_APP_ACTIVITY_EVENTS =
  "FETCH_ACCOUNT_APP_ACTIVITY_EVENTS";
